import styled from "styled-components";

const Main = styled.main`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 80px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  margin-top: 16px;

  @media (min-width: 1024px) {
    margin-top: 32px;
  }
`;

const ErrorHeading = styled.h1`
  font-size: 64px;
  animation: ping 1s infinite;
`;

const StyledLink = styled.a`
  background-color: #355b94;
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  margin-top: 16px;
  text-decoration: none;

  &:hover {
    background-color: #32568c;
  }
`;

const ErrorPage = () => {
  const urlAssinando = process.env.REACT_APP_ASSINANDO;
  return (
    <Main>
      <ContentWrapper>
        <ErrorHeading>404</ErrorHeading>
        <p>Oops, página não encontrada!</p>
      </ContentWrapper>
      <StyledLink href={`${urlAssinando}/inicio`}>Ir para a Home</StyledLink>
    </Main>
  );
};

export default ErrorPage;
